import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { CardMedia, Typography } from '@mui/material'
import { Box, Stack } from '@mui/system'
import React from 'react'
import { Product } from 'src/Libs/shop/models/system-configuration-components.model'
import { ShopImageThumnbailSizes } from 'src/Libs/shop/types'
import { getImageUrlBySize } from 'src/Libs/shop/utils'
import { makeStyles } from 'tss-react/mui'

interface QntmProductConfigurationCardProps {
  product: Product
}

const useStyles = makeStyles()(theme => ({
  mainComponentWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '8px',
  },
  productImage: {
    width: '45px',
    maxWidth: '45px',
    height: 'auto',
  },
}))

const QntmProductConfigurationCard: React.FC<QntmProductConfigurationCardProps> = ({ product }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  return (
    <Stack>
      {product && product.id !== null && (
        <Typography variant="h5" mt={2}>
          {t('shop.system-configure-card.quantum-component')}
        </Typography>
      )}
      <Box className={classes.mainComponentWrapper}>
        <Box className={classes.spaceBetween}>
          <Box>
            <CardMedia
              component="img"
              image={getImageUrlBySize(product.cover?.media?.thumbnails, ShopImageThumnbailSizes.ExtraSmall)}
              className={classes.productImage}
            />
          </Box>
          {product?.translated && (
            <Typography variant="h4" sx={{ wordBreak: 'break-all' }}>
              {product.translated.name}
            </Typography>
          )}
        </Box>
      </Box>
    </Stack>
  )
}

export default QntmProductConfigurationCard
